import React, { useState, useEffect } from "react";
import RoleServices from "services/RoleServices";
import useToggleDrawer from "hooks/useToggleDrawer";
import PageTitle from "components/Typography/PageTitle";
import MainDrawer from "components/drawer/MainDrawer";
import RoleDrawer from "components/drawer/RoleDrawer";
import { useContext } from "react";
import { SidebarContext } from "context/SidebarContext";
import TableLoading from "components/preloader/TableLoading";
import Somethingwentwrong from "pages/Somethingwentwrong";
import DeleteModal from "components/modal/DeleteModal";
import useAsync from "hooks/useAsync";
import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import { FiPlus } from "react-icons/fi";
import sidebar from "routes/sidebar";
import NotFound from "components/table/NotFound";
import ExportData from "components/common/ExportData";
import RoleTable from "components/languageDriver/RoleTable";
import useSidebar from "routes/sidebar";


const style = `.downloadbtn .svg-inline--fa {
  font-size: 30px; 
  color:grey;
  padding: 9px 10px;
  margin: unset;
}`;

const Role = () => {
  const adminInfo = localStorage.getItem("adminInfo")
  ? JSON.parse(localStorage.getItem("adminInfo"))
  : null;
  const { toggleDrawer } = useContext(SidebarContext);
  const [searchText, setSearchText] = useState("");
  const { data, loading } = useAsync(() => RoleServices.getAllRole());
  const [status, setStatus] = useState("");

  const { title, serviceId } = useToggleDrawer();

   const {sidebar} = useSidebar()

  // Contains the column headers and table data in the required format for CSV
  const isDataArray = Array.isArray(data?.data); // Check if data is an array
  const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array

  useEffect(() => {
    if (data?.status) {
      setStatus(data.status);
    } else {
      setStatus(false);
    }
  }, [data?.status]);

  const csvData = [["Role"], ...safeData.map(({ name }) => [name])];

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "role" && perm.view === 1
      );

  const hideDelete = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "role" && perm.delete === 1
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "role" && perm.edit === 1
      );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "role" && perm.add === 1
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "role" && perm.export === 1
      );

  const filteredData = safeData.filter(
    (item) =>
      item.name !== null &&
      item.name.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />
          <style>{style}</style>
          <PageTitle sidebar={sidebar} />

          <MainDrawer>
            <RoleDrawer id={serviceId} />
          </MainDrawer>

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <form className="flex gap-6 items-center">
                <div className="flex-1">
                  <Input
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Search"
                  />
                </div>

                {hideAdd && (
                  <Button
                    onClick={toggleDrawer}
                    className="w-56 rounded-md h-10"
                  >
                    <span className="mr-3">
                      <FiPlus />
                    </span>
                    Add Role
                  </Button>
                )}

                {hideExport && (
                  <ExportData
                    title="Role"
                    exportData={csvData}
                    filename="Role List.csv"
                  />
                )}
              </form>
            </CardBody>
          </Card>

          <div className="data-table-container">
            {loading ? (
              // Display a loading spinner or message while data is being fetched
              <TableLoading row={12} col={6} width={190} height={20} />
            ) : status === false || status === undefined ? (
              <Somethingwentwrong title="Something went wrong, please try again later." />
            ) : safeData.length > 0 ? (
              <TableContainer
                className="mb-8"
                style={{
                  maxHeight: "65vh",
                  overflowY: "scroll",
                  scrollbarWidth: "thin",
                }}
              >
                <Table>
                  <TableHeader className="custom-table-header capitalize sticky top-0 z-10">
                    <tr>
                      <TableCell className="text-center">Sl.No.</TableCell>
                      <TableCell className="text-center">Role</TableCell>
                      <TableCell className="text-center">Actions</TableCell>
                    </tr>
                  </TableHeader>

                  <RoleTable
                    roledata={filteredData}
                    hideEdit={hideEdit}
                    hideDelete={hideDelete}
                  />
                </Table>
              </TableContainer>
            ) : (
              // Show NotFound if there is no data
              <NotFound title="There are no Roles." />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Role;
